import { Component, OnInit, inject } from '@angular/core';
import { ErrorServiceService } from '../../services/error-service.service';
import { User } from '../../classes/user';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { UNAUTHORIZED_AND_FORBIDDEN_CODES } from 'src/app/constants';

@Component({
  selector: 'error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss'],
})
export class ErrorPopupComponent implements OnInit {
  private readonly cookieService = inject(CookieService);
  private readonly errorServiceService = inject(ErrorServiceService);
  private readonly router = inject(Router);

  error = false;
  messageError: string;
  status: number;
  user: User;

  ngOnInit(): void {
    this.errorServiceService.componentMethodCalled$.subscribe((res) => {
      this.error = res.error;
      this.status = res.errorStatus;
      this.messageError = res.messageError.replace(/\n\r?/g, '<br />');
    });
  }

  public logOut(): void {
    if (UNAUTHORIZED_AND_FORBIDDEN_CODES.includes(this.status)) {
      sessionStorage.clear();

      localStorage.removeItem('privileges');
      localStorage.removeItem('createOffer');
      localStorage.removeItem('sections');
      localStorage.removeItem('autoControlChanges');
      localStorage.removeItem('viewOffer');
      localStorage.removeItem('user');

      this.cookieService.delete('UasToken', '/');
      this.cookieService.delete('UasMessage', '/');
      //  this.cookieService.delete('UasLang', '/');
      this.router.navigate(['/']).then(() => location.reload());
    }
  }
}
